import { render, staticRenderFns } from "./BroadcastListCompnent.vue?vue&type=template&id=1c74fb7c&scoped=true"
import script from "./BroadcastListCompnent.vue?vue&type=script&lang=js"
export * from "./BroadcastListCompnent.vue?vue&type=script&lang=js"
import style1 from "./BroadcastListCompnent.vue?vue&type=style&index=1&id=1c74fb7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c74fb7c",
  null
  
)

export default component.exports